import { Typography } from '@material-ui/core';
import { Box, MultilineText } from '@superdispatch/ui-lab';
import { useParams } from 'react-router-dom';
import { DocumentTitle } from 'shared/layout/DocumentTitle';
import { SplashScreen } from 'shared/layout/SplashScreen';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import { useShipperProfile } from 'shared/modules/shipper/LoadboardShipperAPI';
import { WebViewLinkedText } from 'shared/routing/WebViewLinks';

export function TermsAndConditionsPage() {
  const { guid = '' } = useParams();
  const { data: profile } = useShipperProfile(guid);

  if (!profile) {
    return <SplashScreen />;
  }

  return (
    <WebviewLayout>
      <DocumentTitle title="Terms &amp; Conditions" />

      <Box backgroundColor="White" padding="small">
        <Typography aria-label="Terms and condition text">
          {profile.terms_and_conditions && (
            <MultilineText>
              <WebViewLinkedText>
                {profile.terms_and_conditions}
              </WebViewLinkedText>
            </MultilineText>
          )}
        </Typography>
      </Box>
    </WebviewLayout>
  );
}
